<template>
  <!-- login -->
  <main class="member">
    <div class="login member-layout">
      <h1 tabindex="0">로그인</h1>
      <div class="join-sns-box">
        <h2 class="login-box-hd wavve-hd" tabindex="0">
          Wavve 계정으로 로그인
        </h2>
        <form>
          <fieldset>
            <legend>로그인 양식</legend>
            <ul class="input-wrap01">
              <li>
                <label>
                  <input
                    v-model="usrId"
                    type="text"
                    placeholder="이메일 주소 또는 아이디"
                    title="아이디"
                    class="input-style01"
                    @keydown.enter.prevent="login()"
                  />
                </label>
                <p v-if="checkIdMsg !== ''" class="login-error-red">
                  {{ checkIdMsg }}
                </p>
              </li>
              <li>
                <label>
                  <input
                    v-model="usrPwd"
                    type="password"
                    placeholder="비밀번호"
                    title="비밀번호"
                    class="input-style01"
                    @keydown.enter.prevent="login()"
                  />
                </label>
                <p v-if="checkPwdMsg !== ''" class="login-error-red">
                  {{ checkPwdMsg }}
                </p>
                <p
                  v-if="loginMsg !== ''"
                  class="login-error-red"
                  v-html="loginMsg"
                ></p>
              </li>
            </ul>
            <ul class="checkbox-wrap01">
              <li class="check-style check-style-dark">
                <input
                  id="id-save"
                  v-model="saveId"
                  type="checkbox"
                  class="check-blue-dark"
                />
                <label for="id-save">아이디 저장</label>
              </li>
              <li class="check-style check-style-dark">
                <input
                  id="login-auto"
                  type="checkbox"
                  class="check-blue-dark"
                  @click="setAutoLogin()"
                />
                <label for="login-auto">자동 로그인</label>
              </li>
            </ul>
            <div class="btn-purple btn-purple-dark">
              <a href="#" title="로그인" @click.prevent="login()">로그인</a>
            </div>
          </fieldset>
        </form>
        <ul class="join-find">
          <li>
            <a href="https://member.wavve.com/find/id">아이디 찾기</a>
          </li>
          <li>
            <a href="https://member.wavve.com/find/password">비밀번호 재설정</a>
          </li>
          <li>
            <a href="#" @click.prevent="goSignUp">회원가입</a>
          </li>
        </ul>
      </div>
      <div class="sns-box">
        <div class="or-bar-box">
          <span class="or-bar or-bar-left"></span>
          <h2 class="login-box-hd" tabindex="0">
            또는 다른 서비스 계정으로 로그인
          </h2>
          <span class="or-bar or-bar-right"></span>
        </div>
        <div class="login-sns">
          <ul>
            <btn-kakao />
            <btn-skt />
            <btn-naver />
            <btn-facebook />
            <btn-apple />
          </ul>
        </div>
        <p class="sns-exclamation">
          <span
            >SNS계정으로 간편하게 가입하여 서비스를 이용하실 수 있습니다.</span
          >
          <span
            >기존 POOQ 계정 또는 Wavve 계정과는 연동되지 않으니 이용에
            참고하세요.</span
          >
        </p>
      </div>
    </div>
  </main>
  <!--// login -->
</template>

<script>
  import _ from 'lodash'
  import BtnFacebook from '@/components/member/BtnFacebook'
  import BtnKakao from '@/components/member/BtnKakao'
  import BtnNaver from '@/components/member/BtnNaver'
  import BtnSkt from '@/components/member/BtnSkt'
  import BtnApple from '@/components/member/BtnApple'
  import { loginProc } from '@/common/utils/login'
  import cookie from '@/common/utils/cookie'
  import {
    needSelectProfile,
    setEnterChange,
    scrollTop,
    setDisableScrolling,
    titleTagNameChange,
  } from '@/common/utils/common'
  import {
    LOGIN_SUCCESS_EVENT,
    PROMOTION_CODE_KEY,
    SET_CURRENT_MENU,
    SOCIAL_LOGIN_SUCCESS_EVENT,
  } from '@/common/resources/const'
  import { mapMutations } from 'vuex'
  import {
    getEncodedReferer,
    getReferer,
    getSanitizeUrl,
    setReferer,
  } from '@/common/utils/referer'
  import { parseUrl } from 'query-string'

  export default {
    components: {
      BtnFacebook,
      BtnKakao,
      BtnNaver,
      BtnSkt,
      BtnApple,
    },
    data() {
      return {
        userType: 'general',
        usrId: '',
        usrPwd: '',
        saveId: false,
        autoLogin: false,
        loginMsg: '',
        checkIdMsg: '',
        checkPwdMsg: '',
        referer: getReferer(),
      }
    },
    watch: {
      usrId() {
        if (this.usrId.length > 0) this.checkIdMsg = ''
      },
      usrPwd() {
        if (this.usrPwd.length > 0) this.checkPwdMsg = ''
        this.loginMsg = ''
      },
    },
    created() {
      scrollTop()
      setDisableScrolling(false)
      this[SET_CURRENT_MENU]('LOGIN')
      const getQueryReferer = () => _.get(this.$route, 'query.referer', '')
      getQueryReferer() !== ''
        ? setReferer(getQueryReferer())
        : setReferer('/index.html')
      if (cookie.getCredential() !== 'none') {
        const hasReferer = getQueryReferer() !== ''
        setReferer(getQueryReferer())
        if (hasReferer) {
          const referer = this.$route.fullPath.split('referer=').pop()
          this.$router.replace(getSanitizeUrl(referer))
        } else {
          this.$router.replace('/index.html')
        }
      }

      // 소셜 로그인 이벤트 등록
      this.$events.$on(SOCIAL_LOGIN_SUCCESS_EVENT, (needselectprofile) => {
        let destination = ''
        if (needselectprofile === 'y') {
          destination =
            '/member/profile_list.html?referer=' +
            encodeURIComponent(getEncodedReferer())
        } else {
          destination = decodeURIComponent(getEncodedReferer())
        }
        window.location.href = getSanitizeUrl(destination)
      })

      let saveId = cookie.getSaveUserId()
      // 아이디 저장 체크
      if (saveId !== 'none') {
        this.usrId = saveId
        this.saveId = true
      }
      titleTagNameChange('웨이브 로그인')
    },
    beforeDestroy() {
      this.$events.$off(SOCIAL_LOGIN_SUCCESS_EVENT)
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU, 'showMenu']),
      url(url) {
        return location.protocol + '//' + url
      },
      setAutoLogin() {
        this.autoLogin = !this.autoLogin
      },
      isValidation() {
        let loginCheck = true
        if (!this.usrId || this.usrId.trim().length <= 0) {
          this.checkIdMsg = '이메일 또는 아이디를 입력해주세요.'
          loginCheck = false
        } else if (!this.usrPwd || this.usrPwd.trim().length <= 0) {
          this.checkPwdMsg = '비밀번호를 입력해주세요.'
          loginCheck = false
        }
        return loginCheck
      },
      login() {
        if (this.isValidation()) {
          const hasReferer = _.get(this.$route, ['query', 'referer'], null)
          const referer = hasReferer
            ? this.$route.fullPath.split('referer=').pop()
            : '/index.html'
          const sanitizedReferer = getSanitizeUrl(referer)
          loginProc({
            userType: this.userType,
            userId: this.usrId,
            userPassword: this.usrPwd,
            saveId: this.saveId,
            autoLogin: this.autoLogin,
          })
            .then((data) => {
              if (needSelectProfile(data)) {
                this.$router.replace(
                  '/member/profile_list?referer=' +
                    encodeURIComponent(sanitizedReferer),
                )
              } else {
                this.showMenu()
                this.$events.$emit(LOGIN_SUCCESS_EVENT)
                if (sanitizedReferer.indexOf('member.wavve.com') > -1) {
                  location.replace(decodeURIComponent(sanitizedReferer))
                } else {
                  this.$router.replace(decodeURIComponent(sanitizedReferer))
                }
              }
            })
            .catch((error) => {
              alert(
                error.response.data.resultmessage ||
                  error.response.data.message,
              )
              this.loginMsg = this.setEnterHtml(
                error.response.data.resultmessage,
              )
            })
        }
      },
      setEnterHtml(content) {
        return setEnterChange(content)
      },
      goSignUp() {
        const SIGN_UP_URL = 'https://member.wavve.com/signup'
        const { query } = parseUrl(location.href)
        const refererInQuery = _.get(query, 'referer', '')
        let signUpUrl = SIGN_UP_URL
        if (refererInQuery !== '') {
          const { query: refererQuery } = parseUrl(refererInQuery)
          const promotionCode = _.get(refererQuery, PROMOTION_CODE_KEY, '')
          if (promotionCode !== '') {
            signUpUrl = `${SIGN_UP_URL}?${PROMOTION_CODE_KEY}=${promotionCode}`
          }
        }
        location.href = signUpUrl
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>
